// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3u25T","header":"Messages_header__DCvHu"};